import { ChecklistTemplateEditable } from '@/ui/DTO';
import { ChecklistTemplateRecord, ChecklistTemplateSendable } from '@/entities/checklistTemplate';
import { v4 as uuidv4 } from 'uuid';

export const intoSendable = (resource: ChecklistTemplateEditable): ChecklistTemplateSendable => ({
  checklistId: resource.checklistId,
  assignees: resource.assignees,
  assignedGroups: resource.assignedGroups,
  dueIn: resource.dueIn ?? null,
});

export const intoEditable = (resource: ChecklistTemplateRecord): ChecklistTemplateEditable => ({
  id: resource.id,
  title: resource.data.checklist.data.title,
  checklistId: resource.data.checklist.id,
  assignees: resource.data.assignees.map(user => `user_${user.id}`),
  assignedGroups: resource.data.assignedGroups.map(group => `group_${group.id}`),
  dueIn: resource.data.dueIn,
  wasChanged: false,
  softDeleted: false,
  internalId: uuidv4(),
});
